import { Text } from '@/shared/ui/primitives';
import type { FC } from 'react';

import type { ActionLogEntry } from '@/types';
import { getActionLogLabel, isDestructiveKind, renderActionLogIcon } from '../model';
import styles from './ActionTimelineItem.module.css';

interface ActionTimelineItemProps {
  entry: ActionLogEntry;
}

const TIME_FORMATTER = new Intl.DateTimeFormat('en', {
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
});

export const ActionTimelineItem: FC<ActionTimelineItemProps> = ({ entry }) => {
  const { title, description } = getActionLogLabel(entry);
  const destructive = isDestructiveKind(entry.kind);
  const time = TIME_FORMATTER.format(new Date(entry.timestamp));
  const rowClassName = description ? styles.row : `${styles.row} ${styles.rowSingleLine}`;

  return (
    <li className={styles.item}>
      <div className={styles.gutter}>
        <div
          className={
            destructive ? `${styles.iconCircle} ${styles.iconCircleDestructive}` : styles.iconCircle
          }
        >
          {renderActionLogIcon(entry.kind)}
        </div>
        <div className={styles.connector} />
      </div>
      <div className={styles.content}>
        <div className={rowClassName}>
          <Text variant="subheadline" weight="regular" className={styles.title}>
            {title}
          </Text>
          <Text variant="caption" weight="regular" className={styles.time}>
            {time}
          </Text>
        </div>
        {description && (
          <Text variant="caption" weight="regular" className={styles.subtitle}>
            {description}
          </Text>
        )}
      </div>
    </li>
  );
};
